import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useProfileId } from '@/features/org/hooks/use-profile-id';
import { updateLanguage } from '@/features/profile/api/update-language';
import { useUserProfile } from '@/features/profile/hooks/use-user-profile';
import { Language } from '@/shared/types/language';

export function useLanguageSync() {
  const { i18n } = useTranslation();
  const { data: userProfile } = useUserProfile();
  const { data: profileId } = useProfileId();

  useEffect(() => {
    if (!userProfile) return;

    if (userProfile.language) {
      if (userProfile.language !== i18n.language) {
        i18n.changeLanguage(userProfile.language);
      }
    } else if (
      profileId &&
      (i18n.language === 'de' || i18n.language === 'en')
    ) {
      updateLanguage(profileId, i18n.language as Language);
    }
  }, [userProfile, profileId, i18n]);
}
